module.exports = __webpack_public_path__ + "static/media/brujula-de.0a12a7b1.svg";